{
  "hero": {
    "title": "Solutions & Insights",
    "body": "Azure DevOps markdown is pulled, organized by repo, and rendered as project cards with file lists.",
    "actions": [
      {
        "label": "Manage Sources",
        "href": "/manage-sources",
        "variant": "outline"
      },
      {
        "label": "View JSON Index",
        "href": "/jekyll/_projects/index.json",
        "variant": "primary"
      }
    ]
  },
  "projectsGallery": {
    "title": "Web/ Automation / AI Projects",
    "searchPlaceholder": "Label",
    "cards": [
      {
        "repoKey": "DASRD/Browser-Extensions/psa-api",
        "repoSlug": "psa-api",
        "title": "PSA Browser Extension",
        "video": "/assets/project_gallery/highlight/PSA-EXT-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=%2BpfEPM%2FU9vIJGKj8qx4uXSz1Zoa1LdowlrDaQL%2F%2BGy0%3D&docid=2_0ddae48969e084f5e868453bf6e984ee0&rev=1",
        "image": "/assets/project_gallery/thumbnail/PSA-Ext.png",
        "filesCount": 2
      },
      {
        "repoKey": "DASRD/Agentic-Knowledge-Extension/agentic-kb-assistant",
        "repoSlug": "agentic-kb-assistant",
        "title": "Agentic Kb Assistant",
        "video": "/assets/project_gallery/highlight/AKA-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=JlVk1VoVxWXHiZNUx6F%2BSRB2ktCVGSCrSuiN7%2FDdYHA%3D&docid=2_01174b65769d547b089d107b57cd3a333&rev=1",
        "image": "/assets/project_gallery/thumbnail/AKA.png",
        "filesCount": 2
      },
      {
        "repoKey": "DASRD/Quality Audit Agent/llm-instruct-api",
        "repoSlug": "llm-instruct-api",
        "title": "Llm Instruct Api",
        "video": "/assets/project_gallery/highlight/Language-Translation-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=JlVk1VoVxWXHiZNUx6F%2BSRB2ktCVGSCrSuiN7%2FDdYHA%3D&docid=2_01174b65769d547b089d107b57cd3a333&rev=1",
        "image": "/assets/project_gallery/thumbnail/Language-Translation.png",
        "filesCount": 2
      },
      {
        "repoKey": "DASRD/CI/Command Center",
        "repoSlug": "command-center",
        "title": "Command Center",
        "video": "/assets/project_gallery/highlight/Command-Center-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=UQasUVmpUz7WhqoygPJ4kRTlxoyvdqErbidGTHKDC3Q%3D&docid=2_0a577fef46f7b440d9104c0b2fe809a48&rev=1",
        "image": "/assets/project_gallery/thumbnail/Command-Center.png",
        "filesCount": 1
      },
      {
        "repoKey": "DASRD/Telemetry/open-telemetry-instrumentation-docker-swarm",
        "repoSlug": "open-telemetry-instrumentation-docker-swarm",
        "title": "Open Telemetry Instrumentation Docker Swarm",
        "video": "/assets/project_gallery/highlight/Telemetry-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=AlAbQbX6gqdjW4QvljpXJ6JAO%2BugUOYkIgA7tPSz7oY%3D&docid=2_0951e2e8ad21542a797e39377f392ab21&rev=1",
        "image": "/assets/project_gallery/thumbnail/Scryer-Telemetry.png",
        "filesCount": 1
      },
      {
        "repoKey": "DASRD/Quality Audit Agent/qa-forms",
        "repoSlug": "qa-forms",
        "title": "Qa Forms",
        "video": "/assets/project_gallery/highlight/QASS-highlight.mp4",
        "videoEmbed": "https://eu.sharepoint.ent.cgi.com/sites/IN6950/_layouts/15/guestaccess.aspx?guestaccesstoken=mkyGiEPgOKUiJqOqukYVLdE1TQZJZ8fJ9m3tdxz9wMM%3D&docid=2_0aa8af184dc7249b9a1d7d2de3dc964b9&rev=1",
        "image": "/assets/project_gallery/thumbnail/QASS.png",
        "filesCount": 1
      }
    ]
  }
}